import React from "react";

import { CellContext } from "@tanstack/react-table";

import type { LibreViewClinicPatient } from "@/models/LibreViewModel.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { ColumnHeader } from "@/uiKit/organisms/PatientSync/columnHeader.tsx";

export const AgeCell: React.FC<CellContext<LibreViewClinicPatient, number | undefined>> = ({ getValue }) => {
  const value = getValue();
  return <Typography variant="body">{value === undefined ? "" : String(value)}</Typography>;
};

export const AgeHeader: React.FC = () => <ColumnHeader translationKey="patientSync.libreviewTable.age" />;
